import { render, staticRenderFns } from "./UserEditGeneralDetails.vue?vue&type=template&id=25c41528&"
import script from "./UserEditGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditGeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditGeneralDetails.vue?vue&type=style&index=0&id=25c41528&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports